import { css } from "@emotion/react";
import { useState, useEffect } from "react";
import { withFeature } from "flagged";
import "./snow.css";
import { getIsChristmasHolidays } from "@amplio-common/funcs/commonFunctionalities";

const rootStyle = css`
  position: absolute;
  pointer-events: none;
  top: 0;
  left: 0;
  height: 100vh;
  overflow: hidden;
  width: 100%;
  filter: drop-shadow(0 0 10px white);

  .snow-reload {
    position: absolute;
    bottom: -1px;
    right: 2px;
    pointer-events: all;
    cursor: pointer;
  }

  .pileup {
    zoom: 0.1;
    height: 150px;
    width: 100%;
    background: #eee;
    position: absolute;
    bottom: 0;
    animation: snowpile 120s linear forwards;
    transform: translateY(150px);
  }

  @keyframes snowpile {
    0% {
      transform: translateY(150px)
    }
    100% {
      transform: translateY(0px)
    }
  } 
`;

const Snow = () => {
  const [showReload, setShowReload] = useState(false);
  
  useEffect(() => {
    setTimeout(() => setShowReload(true), 1000 * 120);
  }, []);

  const refreshSnow = () => {
    document.querySelectorAll(".snow").forEach(elm => {
      elm.classList.remove("snow");
      setTimeout(() => elm.classList.add("snow"), 100);
      setShowReload(false);
      setTimeout(() => setShowReload(true), 1000 * 120);
    });
  };

  if (!getIsChristmasHolidays()) {
    return null;
  }

  return (
    <div css={rootStyle}>
      {[...Array(60).keys()].map((i) => (
        <div className="snow" key={`snow-${i}`} />
      ))}
      {/* <div className="pileup" /> */}
      { showReload && <div className="snow-reload" onClick={refreshSnow}>⛄</div>}
    </div>
  );
};

export default withFeature("SNOW_NAVIGATION")(Snow);
